import { AuditStatus } from "@/lib/shopConfigAudit";
import { FilteredList } from "@/lib/shopConfigAuditView";
import { STATUS_STYLES } from "./statusStyles";

const GROUPS: {
  key: keyof FilteredList;
  title: string;
  hint: string;
  status: AuditStatus;
}[] = [
  {
    key: "missing",
    title: "Missing",
    hint: "Default items this shop never received.",
    status: "missing",
  },
  {
    key: "extra",
    title: "Shop-added",
    hint: "Not part of the defaults. Informational.",
    status: "drift",
  },
  {
    key: "present",
    title: "Present",
    hint: "Default items the shop has.",
    status: "match",
  },
];

export const ListChips = ({ lists }: { lists: FilteredList }) => {
  const visible = GROUPS.filter((g) => lists[g.key].length > 0);
  if (visible.length === 0) return null;
  return (
    <div className="flex flex-col gap-3.5 px-4 pb-4 pt-3 text-foreground">
      {visible.map((group) => (
        <div key={group.key} className="flex flex-col gap-2">
          <div className="flex flex-col gap-px">
            <span className="text-[13px] font-semibold">
              {`${group.title} (${lists[group.key].length})`}
            </span>
            <span className="text-xs text-muted-foreground">{group.hint}</span>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {lists[group.key].map((item, i) => (
              <span
                key={`${item}-${i}`}
                className={STATUS_STYLES[group.status].listChip}
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
